export default class BookingDateDto {
    id: string;
    agencyId: string;
    bookingId: string;
    date: Date;
}